/**
 * @generated SignedSource<<d801276065e1e6508e0bad8efff94c8b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OnboardingEventInput = {
  entryPoint?: string | null;
  eventName?: string | null;
  payloadJson?: string | null;
};
export type useOnboardingEventTrackingMutation$variables = {
  input: OnboardingEventInput;
};
export type useOnboardingEventTrackingMutation$data = {
  readonly trackOnboardingEvent: boolean;
};
export type useOnboardingEventTrackingMutation = {
  response: useOnboardingEventTrackingMutation$data;
  variables: useOnboardingEventTrackingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "trackOnboardingEvent",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useOnboardingEventTrackingMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useOnboardingEventTrackingMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "2eb08ec058b651e9f8a82ea0567ce641",
    "id": null,
    "metadata": {},
    "name": "useOnboardingEventTrackingMutation",
    "operationKind": "mutation",
    "text": "mutation useOnboardingEventTrackingMutation(\n  $input: OnboardingEventInput!\n) {\n  trackOnboardingEvent(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "718413583c74f52cf2eff9ab676de89e";

export default node;
